import { combineLatest, Subject } from 'rxjs';
import { SectionId } from '../configs/section-id-enum';
import { SagittaScoreAreaDto } from '../dto/sagitta-score-area-dto';
import { SagittaScoreFactory } from './sagitta-score-factory';
import { SagittaScoreSection } from './sagitta-score-section';

export class SagittaScoreArea {
  counter$ = new Subject<number>();
  private _total: number;
  get total() {
    return this._total;
  }

  private _contributionToScoreComplessivo = 0;
  get contributionToScoreComplessivo() {
    return this._contributionToScoreComplessivo;
  }

  private _base100 = 0;
  get base100() {
    return this._base100;
  }

  elementCounter: number;

  constructor(
    public title: string,
    public area: 'A' | 'B' | 'C' | 'D' | 'E' | 'X',
    public weight: number,
    public sections: SagittaScoreSection[]
  ) {
    this._total = 0;
    this.elementCounter = this.sections
      .map((s) => s.rows)
      .flat()
      .map((row) => row.elements)
      .flat()
      .filter((el) => el.id !== SectionId.identificazioneDelSettore).length;
    let counter$ = this.sections.map((section) => section.counter$);
    combineLatest(counter$).subscribe((counters) => {
      this.updateTotal(counters);
    });
  }

  updateTotal(counters: number[]) {
    this._total = this.calcTotal(counters);
    this._base100 = this.calcBase100(this.total);
    this._contributionToScoreComplessivo =
      this.calcContributionToScoreComplessivo(this._base100, this.weight);
    this.counter$.next(this._contributionToScoreComplessivo);
  }

  private calcTotal(counters: number[]) {
    if (this.area === 'A' || this.area === 'E' || this.area === 'X') {
      return counters.reduce((c, acc) => c + acc);
    }
    let os = counters.map((counter, i) => {
      let w = this.sections[i].weight / 100;
      return {
        n: counter,
        d: counter > 0 ? 1 * w : 0 * w,
      };
    });
    if (this.area === 'C') {
      os.pop();
    }
    let r = os.reduce((o, acc) => ({
      n: o.n + acc.n,
      d: o.d + acc.d,
    }));
    const total = r.d ? r.n / r.d : 0;
    //og(this.area + ': ' + total);

    if (this.area === 'C' && counters[counters.length - 1] === -1) {
      if (total > 3.2) {
        return 3.2;
      }
    }

    return total;
  }

  private calcBase100(areaTotal: number, start = 1, attempt = start) {
    const base = this.roundTo9Digits(4 / 99);
    let next = this.roundTo9Digits(start + base);
    let diffStart = this.roundTo9Digits(Math.abs(areaTotal - start));
    let diffNext = this.roundTo9Digits(Math.abs(areaTotal - next));
    if (start >= areaTotal || diffStart < diffNext || attempt >= 100) {
      // console.log(diffStart);
      // console.log(diffNext);
      //console.log(areaTotal);
      // console.log(start);
      // console.log(next);
      // console.log(attempt);
      return attempt;
    } else {
      return this.calcBase100(areaTotal, next, attempt + 1);
    }
  }
  private roundTo9Digits(amount: number) {
    const rounded = Math.floor(amount * Math.pow(10, 9)) / Math.pow(10, 9);
    return rounded;
  }

  private calcContributionToScoreComplessivo(
    base100: number,
    areaWeight: number | null
  ) {
    let areaContribution = 0;
    if (this.area === 'X') {
      return this.total;
    }
    if (areaWeight) {
      //areaContribution = areaTotal * (100 / 5) * (areaWeight / 100);

      //let base100 = this.calcBase100(1, Math.round(areaTotal * 10) / 10);

      areaContribution = base100 * (areaWeight / 100);
      //areaContribution = (areaTotal * areaWeight) / 100;
    }
    return areaContribution;
  }

  static genDto(scoreArea: SagittaScoreArea): SagittaScoreAreaDto {
    let areaDto: SagittaScoreAreaDto = {
      area: scoreArea.area,
      score: SagittaScoreFactory.round(scoreArea.total) || 0,
      title: scoreArea.title,
      weight: scoreArea.weight,
      sections: scoreArea.sections.map((section) => {
        return SagittaScoreSection.genDto(section, scoreArea.area);
      }),
    };
    return areaDto;
  }
}
